<template>
	<div class="card">
		<header class="card-header language-list">
			<h3 class="card-title">Redirects</h3>
		</header>
		<div class="card-body">
			<div v-if="metaSeoRedirects.redirectsFrom.length !== 0 || metaSeoRedirects.redirectsTo.length !== 0">
				<section v-if="metaSeoRedirects.redirectsFrom.length > 0 && metaSeoRedirects.redirectsTo.length > 0">
					<div class="alert alert-danger">
						<div class="alert-icon">
							<i class="fas fa-skull-crossbones"></i>
						</div>
						<div class="alert-content">
							<h4>Houston, there's a problem!</h4>
							<p>This shouldn't happen, but it just did. Please fix this immediately.</p>
							<a class="btn btn-lg btn-danger mt-1" href="/proprivacy/redirects">Fix Redirect Issue</a>
						</div>
					</div>
				</section>
				<section v-if="metaSeoRedirects.redirectsFrom.length > 0">
					<h4 class="card-subtitle">From</h4>
					<div class="table-responsive">
						<table>
							<thead>
								<tr>
									<th>Type</th>
									<th>From</th>
									<th>Updated</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="redirect in metaSeoRedirects.redirectsFrom">
									<td>{{ redirect.type }}</td>
									<td>
										<a :href="redirect.url_from" rel="noopener noreferrer" target="_blank">{{ redirect.url_from }}</a>
									</td>
									<td>{{ redirect.updated_at }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</section>
				<section v-if="metaSeoRedirects.redirectsTo.length > 0">
					<h4 class="card-subtitle">To</h4>
					<div class="table-responsive">
						<table>
							<thead>
								<tr>
									<th>URL</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="redirect in metaSeoRedirects.redirectsTo">
									<td>
										<a :href="redirect.url_to" rel="noopener noreferrer" target="_blank">{{ redirect.url_to }}</a>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</section>
			</div>
			<p class="no-redirects" v-else>There are no redirects applied to this article.
				<a href="/proprivacy/redirects" target="_blank">Create one?</a></p>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			metaSeoRedirects: {
				required: true
			}
		}
	}
</script>

<style scoped>

</style>
